import { cn } from './cn';

export const CLEAR_BUTTON_HOVER_GROUP_CLASS = 'group/clear-button-hover';

export const CLEAR_BUTTON_ON_HOVER_CLASS = cn(
  'pointer-events-none opacity-none',
  'transition-[opacity,background-color] duration-100 ease-out',
  'group-hover/clear-button-hover:opacity-full group-hover/clear-button-hover:delay-200',
  'group-focus-within/clear-button-hover:opacity-full',
  'group-hover/clear-button-hover:animate-dropdown-delay-clear',
  'group-focus-within/clear-button-hover:animate-dropdown-delay-clear',
);
